import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

// Validation Schema
const PrivacySchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  content: Yup.string().required("Privacy content is required"),
});

const TermsForm = ({ isOpen, toggle, defaultData, onSubmit }) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await onSubmit(values); // API call from parent
      toggle(); // Close modal after save
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Edit Terms and Condition</ModalHeader>

      <Formik
        initialValues={{
          title: defaultData?.title || "Terms and Condition",
          content: defaultData?.content || "",
        }}
        validationSchema={PrivacySchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ errors, touched }) => (
          <Form>
            <ModalBody>
              {/* TITLE */}
              <FormGroup>
                <Label>Title</Label>
                <Field
                  name="title"
                  className="form-control"
                  placeholder="Enter privacy page title"
                />
                {errors.title && touched.title && (
                  <div className="text-danger small">{errors.title}</div>
                )}
              </FormGroup>

              {/* CONTENT */}
              <FormGroup>
                <Label>Content</Label>
                <Field
                  as="textarea"
                  name="content"
                  className="form-control"
                  style={{ minHeight: "250px" }}
                />
                {errors.content && touched.content && (
                  <div className="text-danger small">{errors.content}</div>
                )}
              </FormGroup>
            </ModalBody>

            <ModalFooter>
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>

              <Button color="primary" type="submit" disabled={loading}>
                {loading ? <Spinner size="sm" /> : "Save"}
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default TermsForm;
